import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { formatDate } from '../../../../../utils/formatters';

const OverDueExceptionReportRow = ({ rowData, id, nestedColumnsNumber, slNo }) => {
  const { purchaserName, purchaserOPI, contractDetails } = rowData;
  return (
    <tr key={id} className="table-body-tr">
      <td width="50px" align="center" className="valign-middle">
        {slNo}
      </td>
      <td className="valign-middle">
        <div>{purchaserOPI}</div>
      </td>
      <td className="valign-middle">
        <div className="mb-1 display-block">{purchaserName}</div>
      </td>
      {[...Array(nestedColumnsNumber)].map((_col, column) => {
        return (
          <td key={column} className="p-0 tb-next td-next-1">
            {contractDetails?.map((serviceType, stIndex) => {
              return (
                <table key={stIndex} className="inner-table">
                  <tbody>
                    {serviceType.unitDetails.map((rowDataValues) => {
                      return (
                        <>
                          {column === 0 && (
                            <tr className="tr-next">
                              <td>{serviceType?.contractNumber}</td>
                            </tr>
                          )}
                          {column === 1 && (
                            <tr className="tr-next">
                              <td>{serviceType?.addendumStatus}</td>
                            </tr>
                          )}
                          {column === 2 && (
                            <tr className="tr-next">
                              <td>{formatDate(serviceType?.contractSubmissionDate)}</td>
                            </tr>
                          )}
                          {column === 3 && (
                            <tr className="tr-next">
                              <td>{formatDate(rowDataValues?.expectedPaymentDate)}</td>
                            </tr>
                          )}
                          {column === 4 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.originalPrincipal)}</td>
                            </tr>
                          )}
                          {column === 5 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.originalInterest)}</td>
                            </tr>
                          )}

                          {column === 6 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.remainingPrincipalToBePaid)}</td>
                            </tr>
                          )}
                          {column === 7 && (
                            <tr className="tr-next">
                              <td>{getPrice(rowDataValues?.remainingInterestToBePaid)}</td>
                            </tr>
                          )}
                          {column === 8 && (
                            <tr className="tr-next">
                              <td>{rowDataValues?.dueDays}</td>
                            </tr>
                          )}
                          {column === 9 && (
                            <tr className="tr-next">
                              <td>{formatDate(serviceType?.lastPaymentDate)}</td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              );
            })}
          </td>
        );
      })}
    </tr>
  );
};

OverDueExceptionReportRow.propTypes = {
  id: PropTypes.number.isRequired,
  nestedColumnsNumber: PropTypes.number.isRequired,
  slNo: PropTypes.number.isRequired,
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string,
    purchaserOPI: PropTypes.string,
    contractDetails: PropTypes.shape([
      {
        contractNumber: PropTypes.string,
        contractSubmissionDate: PropTypes.string,
        unitDetails: PropTypes.shape([
          {
            expectedPaymentDate: PropTypes.string,
            originalPrincipal: PropTypes.number,
            originalInterest: PropTypes.number,
            remainingPrincipalToBePaid: PropTypes.number,
            remainingInterestToBePaid: PropTypes.number,
            dueDays: PropTypes.number,
          },
        ]),
      },
    ]),
  }).isRequired,
};

export default OverDueExceptionReportRow;
